import { delay } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class TermDepositProductInfoService {

  constructor(
    private httpClient: HttpClient) {
  }

  getTermDepositProductInfo(id) {
    return this.httpClient.get(
      `${environment.API_ENDPOINT}term-deposit-products/${id}`)
      .pipe(delay(environment.RESPONSE_DELAY));
  }
}
